import React from "react";
import Header from "../components/Header";
import { CardsVenda } from "../components/Cards/CardsVenda";
import { Button } from "../components/Button/Button";

function VendasOnline({ decrement }) {
  return (
    <>
      <Header />
      <CardsVenda />
      <Button decrement={decrement} />
    </>
  );
}

export default VendasOnline;
